import React from "react";
import { Link } from "react-router-dom";
import { utils } from "../../../core/helpers";
import { all_routes } from "../../../feature-module/router/all_routes";

interface BreadcrumbProps {
  title: string;
  subtitles?: any[];
}

const navigateToHome = () => {
  utils.deleteStore("selectedLevel");
  utils.deleteStore("selectedCategory");
  window.location.href = all_routes.home;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ title, subtitles = [] }) => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar text-center">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title mb-2">{title}</h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#" onClick={navigateToHome}>Home</Link>
                  </li>
                  {subtitles.map((subtitle, index) => (
                    <li className="breadcrumb-item" key={index}>
                      <Link to={subtitle.link}>{subtitle.title}</Link>
                    </li>
                  ))}
                  {subtitles.length === 0 && (
                    <li className="breadcrumb-item active" aria-current="page">
                      {title}
                    </li>
                  )}
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* /Breadcrumb */}
    </>
  );
};

export default Breadcrumb;
